<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="비상대피 안내도 관리" device="web">
        <template v-slot:body>
          <v-layout column>
            <DxDataGrid
              id="datagridRef"
              width="100%"
              class="layout-col-height00"
              :ref="dxDataGridRef"
              :data-source="datagrid"
              :show-borders="true"
              :show-row-lines="true"
              :column-auto-width="true"
              :allow-column-resizing="true"
              :allow-column-reordering="true"
              :focused-row-enabled="true"
              key-expr="id"
              @editor-preparing="onEditorPreparing"
            >
              <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

              <DxScrolling row-rendering-mode="standard" />

              <DxSelection
                select-all-mode="allPages"
                show-check-boxes-mode="always"
                mode="multiple"
              />
              <DxColumn data-field="id" data-type="number" alignment="center" :visible="false" />
              <DxColumn
                data-field="clntId"
                data-type="string"
                alignment="left"
                caption="고객번호"
                :visible="false"
              />
              <DxColumn
                data-field="compId"
                data-type="string"
                alignment="left"
                caption="사업장번호"
                :visible="false"
              />
              <DxColumn
                data-field="writeDt"
                data-type="string"
                alignment="left"
                caption="작성일"
                :visible="false"
              />
              <DxColumn
                data-field="docNo"
                data-type="string"
                alignment="left"
                caption="문서번호"
                :visible="false"
              />
              <DxColumn
                data-field
                data-type="string"
                width="120px"
                alignment="center"
                caption
                :allow-editing="false"
                cell-template="actionTemplete"
              ></DxColumn>
              <template #actionTemplete="{ data: cellInfo }">
                <v-btn
                  color="primary"
                  elevation="0"
                  dark
                  small
                  @click="btnDetail(cellInfo)"
                  class="grid-btn rounded"
                >상세보기</v-btn>
              </template>
              <DxColumn
                data-field="guideMapNm"
                width="340px"
                data-type="string"
                alignment="left"
                caption="비상대피 안내도 명"
                :allow-editing="false"
                css-class="devest-grid-header-require"
              />
              <DxColumn
                data-field="finalApply"
                width="100px"
                data-type="boolean"
                alignment="center"
                caption="최종 적용"
                edit-cell-template="checkBoxEditor"
              />
              <DxColumn
                data-field="remark"
                data-type="string"
                alignment="left"
                :allow-editing="false"
                caption="비고"
                :min-width="200"
              />
              <template #checkBoxEditor="{ data: cellInfo }">
                <DxCheckBox
                  :value="cellInfo.value == 'Y' ? true : false"
                  :on-value-changed="value => onCheckValueChanged(value, cellInfo)"
                />
              </template>
            </DxDataGrid>
          </v-layout>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer
            v-model="procedureShow"
            width="75%"
            absolute
            right
            temporary
            class="feedback-area"
          >
            <ProcedureComponent :type="true" :subTitle="'절차서'" :pageTitle="'LeaderShip'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap" :class="{ 'guide-highlight-add': guideHighlightAdd }">
        <i-card-right
          :useBtnList="buttonUseList"
          @btnAdd="btnAdd()"
          @btnSearch="btnSearch(true)"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
        ></i-card-right>
        <!-- <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>-->
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'

import {
  getEmergencyGuideMap,
  saveEmergencyGuideMap,
  deleteEmergencyGuideMap,
  checkApplyGuideMap
} from '@/api/emergencyActionPlan/emergencyGuideMap.js'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    // 절차서 컴포넌트
    ProcedureComponent
  },
  data() {
    return {
      dxDataGridRef: 'datagridRef',
      datagrid: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnSave', //저장
        'btnDelete', //삭제
        'btnAdd' //추가
      ],
      selectedRow: {},
      initFiles: [],
      initCompId: '',
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
      guideHighlightAdd: false, // 안전보건관리체계 구축 진행도 이동 시 추가 버튼 깜빡임
      _guideHighlightTimer: null,
    }
  },
  watch: {
    // 안전보건관리체계 구축 진행도에서 같은 경로로 재이동할 때(query._t) 가이드 하이라이트 재적용
    '$route.query._t'(val, oldVal) {
      if (val && oldVal && val !== oldVal && this.$route.params?.data?.guideHighlight) {
        this.applyGuideHighlightFromRoute()
      }
    },
  },
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
    this.btnSearch(true)
  },
  computed: {},
  beforeMount() {},
  mounted() {
    this.btnSearch(true)
    this.applyGuideHighlightFromRoute()
  },
  activated() {
    if (this.$route.params?.data?.guideHighlight) {
      this.applyGuideHighlightFromRoute()
    }
    if (this.$route.params?.search) {
      // 디테일 페이지에서 삭제, 추가 등 이벤트 발생 후 그리드 페이지 진입할 때
      this.btnSearch(true)
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch(true)
    }
  },
  beforeDestroy() {
    if (this._guideHighlightTimer) {
      clearTimeout(this._guideHighlightTimer)
      this._guideHighlightTimer = null
    }
  },
  methods: {
    // 안전보건관리체계 구축 진행도에서 진입 시 추가 버튼을 붉게 깜빡여 안내
    applyGuideHighlightFromRoute() {
      const routeData = this.$route.params && this.$route.params.data
      if (!routeData || !routeData.guideHighlight) return

      if (this._guideHighlightTimer) {
        clearTimeout(this._guideHighlightTimer)
        this._guideHighlightTimer = null
      }
      this.guideHighlightAdd = false
      this.$nextTick(() => {
        this.guideHighlightAdd = true
        this._guideHighlightTimer = setTimeout(() => {
          this.guideHighlightAdd = false
          this._guideHighlightTimer = null
        }, 5000)
      })
    },
    forceRerender() {
      this.componentKey += 1
    },
    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true
      })
      const toRouter = {
        name: 'EmergencyGuideMapManageDetail',
        params: {
          data: data
        }
      }
      this.$router.push(toRouter)
    },
    async btnDetail(cellInfo) {
      const toRouter = {
        name: 'EmergencyGuideMapManageDetail',
        params: {
          data: {
            clntId: cellInfo.data.clntId,
            compId: cellInfo.data.compId,
            writeDt: cellInfo.data.writeDt,
            docNo: cellInfo.data.docNo
          }
        }
      }
      console.log(toRouter)
      this.$router.push(toRouter)
    },
    btnSearch(isNotify) {
      this.openLoading('searching')
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId()
      }
      getEmergencyGuideMap(params, isNotify)
        .then(response => {
          if (response.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.datagrid = response.list
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnSave() {
      this.GetDataGrid(this.dxDataGridRef).beginUpdate()
      this.GetDataGrid(this.dxDataGridRef).saveEditData()

      var selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        this.GetDataGrid(this.dxDataGridRef).endUpdate()
        return
      }
      selectedRows.forEach(row => (row.__master__ = true))

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.openLoading('saving')

          saveEmergencyGuideMap(selectedRows, true)
            .then(response => {
              if (response.success) {
              }
            })
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
              this.btnSearch(false)
            })
        },
        null,
        true
      )
    },

    async btnDelete() {
      this.GetDataGrid(this.dxDataGridRef).saveEditData()

      var selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }

      checkApplyGuideMap(selectedRows)
        .then(response => {
          if (response.success) {
            this.vToastifyPrompt(
              this.$t('doDeleteData'),
              'info',
              current => {
                this.openLoading('deleting')
                deleteEmergencyGuideMap(selectedRows, true)
                  .then(response => {
                    if (response.success) {
                      this.endLoading()
                      this.btnSearch(false)
                    }
                  })
                  .catch(error => {
                    if (error.response && error.response.data) {
                      if (error.response.data.code == -6026) {
                        this.vSnackbar(error.response.data.msg, 'warn')
                        this.endLoading()
                      }
                    }
                  })
              },
              null,
              true
            )
          }
        })
        .catch(error => {
          if (error.response && error.response.data) {
            if (error.response.data.code == -6037) {
              this.vSnackbar(error.response.data.msg, 'warn')
              this.endLoading()
            }
          }
        })
    },
    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach(key => {
        index = this.datagrid.findIndex(obj => obj == key)
        this.datagrid.splice(index, 1)
      })
    },
    onCheckValueChanged(value, cellInfo) {
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      // this.GetDataGrid(this.dxDataGridRef).cellValue(cellInfo.row.key, cellInfo.column.dataField, cellInfo.value === 'Y' ? 'N' : 'Y')
      console.log(cellInfo)

      this.onDuplicateValueChanged(cellInfo)

      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.saveEditData()
      cellInfo.component.updateDimensions()
    },
    onDuplicateValueChanged(cellInfo) {
      if (cellInfo.value === 'Y' && cellInfo.column.dataField === 'finalApply') {
        console.log(this.datagrid)
        this.datagrid.forEach(row => {
          if (row.finalApply === 'Y') {
            this.GetDataGrid(this.dxDataGridRef).selectRows(row.id, true)
            let rowIndex = this.GetDataGrid(this.dxDataGridRef).getRowIndexByKey(row.id)
            this.GetDataGrid(this.dxDataGridRef).cellValue(rowIndex, cellInfo.column.dataField, 'N')
          }
        })
      }
    },
    //데이터 수정 시 로우 선택되도록
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    }
  }
}
</script>
<style lang="scss">
@keyframes guide-blink-red {
  0%,
  100% {
    color: inherit;
    box-shadow: inset 0 0 0 0 transparent;
    outline: 2px solid transparent;
    background-color: transparent;
  }
  50% {
    color: #f44336 !important;
    box-shadow: inset 0 0 0 2px rgba(244, 67, 54, 0.85);
    outline: 2px solid #f44336;
    background-color: rgba(244, 67, 54, 0.12);
  }
}

.guide-highlight-add .btn_btnAdd {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}
</style>
